export default __webpack_public_path__ + "static/media/AVERY_5384.2082e64a.png";